import { API_URL } from "config";
import Http from "util/https";
import { StoreTargetApiParams, TargetStore, TargetStorePlain } from "../types";

/**
 * 店舗選択肢取得Api
 * @returns レスポンスデータ
 */
export default async function getStoreDataApi(): Promise<TargetStore[]> {
  const http = Http.default.alterAuth({ useToken: true });
  const url = `${API_URL}/order/target/stores`;
  const res = await http.get<TargetStorePlain>(url);
  console.log(res);

  const stores: TargetStore[] = res.data.stores.map((s) => ({
    client_cd: s.client_cd,
    store_name: s.store_name,
    is_client: 0
  }))
  const clients: TargetStore[] = res.data.clients.map((c) => ({
    client_cd: c.client_cd,
    store_name: c.client_store_name,
    is_client: 1
  }));
  const list = [...stores, ...clients];

  return list;
}
